export default __webpack_public_path__ + "static/media/fb_help4.cdf12b14.svg";